export const UserRoles = {
  Driver: 'driver',
  FleetManager: 'fleetmanager',
  Prospect: 'prospect',
  Administrator: 'administrator',
};
